import * as XLSX from "xlsx";
import { formatDate } from "@/lib/format";

export function exportLeads(leads, filtered = false) {
  const rows = leads.map((l) => ({
    "Lead ID": l.id,
    "Created Date": formatDate(l.createdDate),
    "Client": l.name,
    "Phone": String(l.phone || ""),
    "Email": l.email || "",
    "Purpose": l.purpose || "",
    "Property Type": l.propertyType || "",
    "Budget": l.budget || "",
    "Locations": (l.locations || []).join(", "),
    "Configuration": l.configuration || "",
    "Timeline": l.timeline || "",
    "Priorities": (l.priorities || []).join(", "),
    "Advisor": l.advisor || "Unassigned",
    "Stage": l.stage || "",
    "Last Activity": formatDate(l.lastActivity),
    "Next Follow-up": l.nextFollowUp ? formatDate(l.nextFollowUp) : "—",
    "Source": l.source || "",
    "Notes": l.notes || "",
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 12 }, { wch: 14 }, { wch: 18 }, { wch: 16 }, { wch: 24 }, { wch: 12 },
    { wch: 14 }, { wch: 16 }, { wch: 28 }, { wch: 14 }, { wch: 14 }, { wch: 30 },
    { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 12 }, { wch: 40 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Leads");
  const date = new Date().toISOString().slice(0, 10);
  const filename = filtered ? `Archedia_Filtered_Leads_${date}.xlsx` : `Archedia_Leads_${date}.xlsx`;
  XLSX.writeFile(wb, filename);
  return filename;
}
